// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Light Theme */
:root {
  --background-color: #ffffff;
  --text-color: #333333;
  --header-background-color: #ffffff;
  --input-background-color: #f2f2f2;
  --button-color: #4a4a4a;
  --user-message-background: #d3d3d3;
  --assistant-message-background: #f9f9f9;
  --hover-background-color: #e0e0e0; 
  --hover-text-color: #333333;
  --sidebar-background: #f8f9fa;
  --sidebar-border: #e9ecef;
  --accent-color: #007bff;
  --card-background: #ffffff;
  --card-border: #e9ecef;
  --card-hover: #f8f9fa;
  --muted-color: #6c757d;
  --divider-color: #e9ecef;
  --success-color: #28a745;
  --success-hover: #218838;
  --scrollbar-color: #cbd5e0;
  --scrollbar-hover: #a0aec0;
}

/* Dark Theme (default) */
[data-theme='dark'] {
  --background-color: #1e1e1e;
  --text-color: #e0e0e0;
  --header-background-color: #333333;
  --input-background-color: #2e2e2e;
  --button-color: #d3d3d3;
  --user-message-background: #2f2f2f;
  --assistant-message-background: #444444;
  --hover-background-color: #555555; 
  --hover-text-color: #e0e0e0;
  --sidebar-background: #2d3748;
  --sidebar-border: #4a5568;
  --accent-color: #4a90e2;
  --card-background: #4a5568;
  --card-border: #718096;
  --card-hover: #2d3748;
  --muted-color: #a0aec0;
  --divider-color: #4a5568;
  --success-color: #28a745;
  --success-hover: #218838;
  --scrollbar-color: #4a5568;
  --scrollbar-hover: #718096;
}

/* General styling */
body, html {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
  height: 100%;
  background-color: var(--background-color);
  color: var(--text-color);
}

/* App Container - Keep original layout intact */
.app-container {
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-width: 100vw;
}

/* Sidebar will overlay on top, not push content */
/* No margin adjustments needed for main content */


/* Header styling */
.site-header {
  display: flex;
  justify-content: space-between; 
  align-items: center;
  padding: 10px 30px;
  background-color: var(--header-background-color);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  height: 60px;
  position: relative;
}

.site-logo {
  width: 160px; 
  height: auto;
}


.header-text {
  position: absolute; 
  left: 50%; 
  transform: translateX(-50%);
  text-align: center;
  padding-top:5px;
}


.header-text h2 {
  margin: 0;
  font-size: 28px;
  color: var(--text-color);
  font-weight: 600;
}

.header-subtitle {
  margin: 4px 0 0 0;
  font-size: 14px;
  color: var(--text-color);
  opacity: 0.8;
  font-weight: 400;
  line-height: 1.3;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
}

.guided-run-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  position: relative;
  overflow: hidden;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.guided-run-btn:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.guided-run-btn:active {
  transform: translateY(-1px) scale(1.02);
}

.guided-run-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}

.guided-run-btn:hover::before {
  left: 100%;
}

/* Theme toggle positioning */
.theme-toggle {
  z-index: 10;
}

.theme-toggle-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: var(--button-color);
  margin-left: auto;
}

/* Chat container */
.chat-container {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  background-color: var(--background-color);
  margin: 0 auto;
  max-width: 900px;
  width: 100%;
  padding: 0 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  min-height: 0;
  box-sizing: border-box;
}

/* Responsive design for chat container */
@media (max-width: 1024px) {
  .chat-container {
    max-width: 800px;
    padding: 0 15px;
  }
}

@media (max-width: 768px) {
  .chat-container {
    max-width: 100%;
    padding: 0 10px;
  }
}

/* Chat window */
.chat-window {
  flex: 1 1;
  padding: 20px 0;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  scroll-behavior: smooth;
  box-sizing: border-box;
}

/* User message bubble */
.user-message {
  align-self: flex-end;
  background-color: var(--user-message-background);
  color: var(--text-color);
  border-radius: 18px;
  padding: 0px 15px;
  margin-bottom: 10px;
  max-width: 75%;
  font-family: 'Inter', Arial, sans-serif;
  font-size: 14px;
  overflow-wrap: break-word;
  word-break: break-word;
}

/* Assistant message */
.assistant-message-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  width: 100%;
}

.assistant-icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.assistant-text {
  
  max-width: 80%;
  padding: 10px;
  font-family: 'Inter', Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 15px;
}

.assistant-text {
  color: var(--text-color);
  max-width: 100%;
  padding: 10px;
  font-family: 'Inter', Arial, sans-serif;
  font-size: 16px; 
  line-height: 1.5; 
  width: 100%; 
}

/* Input area */
.input-area {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: transparent;
  border-top: none;
  max-width: 100%;
  position: relative;
  flex-shrink: 0;
  order: 2;
}

.chat-input-container {
  position: relative;
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.chat-input {
  flex-grow: 1;
  padding: 15px;
  font-size: 14px;
  border: none;
  border-radius: 50px;
  padding: 15px 90px 15px 40px;
  background-color: var(--input-background-color);
  color: var(--text-color);
  outline: none;
  resize: none;
  font-family: 'Inter', Arial, sans-serif;
  height: 25px;
  line-height: 26px;
}

/* Send button */
.send-button {
  position: absolute;
  right: 45px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--button-color);
  transition: all 0.2s ease;
}

.send-button:hover:not(.disabled) {
  color: #0056b3;
  transform: translateY(-1px);
}

.send-button.disabled {
  color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

/* Mic button */

/*
.mic-button {
  position: absolute;
  right: 9px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: var(--button-color);
}

.mic-button.recording {
  border: 3px solid green;
  border-radius: 50%;
  padding: 5px;
}

*/

.mic-button {
  position: absolute;
  right: 9px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: var(--button-color);
  transition: transform 0.3s ease-in-out;
}

.mic-button.disabled {
  color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

.mic-button.recording {
  border: 3px solid green;
  border-radius: 50%;
  padding: 5px;
  animation: pulse-glow 1.5s infinite ease-in-out;
  box-shadow: 0 0 8px 3px rgba(0, 255, 0, 0.5); 
}

@keyframes pulse-glow {
  0% {
    transform: scale(1);
    box-shadow: 0 0 8px 3px rgba(0, 255, 0, 0.5);
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 0 10px 5px rgba(0, 255, 0, 0.7);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 8px 3px rgba(0, 255, 0, 0.5);
  }
}


/* Loading indicator */
.loading-indicator {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 10px;
  margin-bottom: 20px;
  padding: 10px 0;
}

.dot {
  font-size: 24px;
  margin: 0 3px;
  color: #888;
  animation: bounce 1.5s infinite;
}

/* Bouncing animation for loading dots */
@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

/* Adding delay for each dot to bounce in sequence */
.loading-indicator .dot:nth-child(1) {
  animation-delay: 0s;
}

.loading-indicator .dot:nth-child(2) {
  animation-delay: 0.3s;
}

.loading-indicator .dot:nth-child(3) {
  animation-delay: 0.6s;
}


/* Attachment button */
.attachment-button {
  position: absolute;
  left: 10px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: var(--button-color);
  top: 17px;
}

/* Hide scrollbar in Webkit browsers (Chrome, Safari) */
/* Show scrollbar for chat window */
.chat-window::-webkit-scrollbar {
  width: 8px;
}

.chat-window::-webkit-scrollbar-track {
  background: transparent;
}

.chat-window::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.chat-window::-webkit-scrollbar-thumb:hover {
  background: #999;
}

[data-theme='dark'] .chat-window::-webkit-scrollbar-thumb {
  background: #555;
}

[data-theme='dark'] .chat-window::-webkit-scrollbar-thumb:hover {
  background: #777;
}

/* Hide scrollbar for input only */
.chat-input::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar in Firefox for input only */
.chat-input {
  scrollbar-width: none; /* Firefox */
}

/* Hide scrollbar in IE, Edge for input only */
.chat-input {
  -ms-overflow-style: none;
}

.theme-toggle-switch {
  position: relative;
  width: 50px;
  height: 24px;
  border-radius: 12px;
  background: linear-gradient(to right, #FFF4E0, #FFE8CC);
  /* old background: linear-gradient(to right, #b0d4ff, #82b1ff);*/
  cursor: pointer;
  transition: background 0.3s ease;
  display: flex;
  align-items: center;
}

.theme-toggle-switch:before {
  content: '☀️';
  position: absolute;
  top: 2.5px;
  left: 4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: transparent; /* old white*/
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: transform 0.3s ease, background-color 0.3s ease;
  color: black; /* old transparent*/
}

.theme-toggle-switch:after {
  position: absolute;
  top: 8px;
  left: 28px;
  font-size: 6px;
  color: rgba(255, 255, 255, 0.8);
  opacity: 1;
  transition: opacity 0.3s ease;
}

[data-theme='dark'] .theme-toggle-switch {
  background: linear-gradient(to right, #334, #223);
}

[data-theme='dark'] .theme-toggle-switch:before {
  content: '🌙';
  transform: translateX(26px);
  background-color: transparent;
  color: white;
}

[data-theme='dark'] .theme-toggle-switch:after {
  font-size: 8px;
  left: 6px;
  top: 4px;
  color: rgba(255, 255, 255, 0.7);
}


.file-upload-bubble {
  display: flex;
  align-items: center;
  background-color: var(--user-message-background);
  color: var(--text-color);
  padding: 8px 10px; 
  border-radius: 12px;
  max-width: 250px; 
  margin-bottom: 10px;
  overflow: hidden;
}

.file-icon {
  font-size: 18px; 
  color: #4a90e2;
  margin-right: 8px;
}

.file-name {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.suggestion-bubbles {
  display: flex;
  gap: 10px;
  padding: 10px 20px;
  background-color: var(--background-color);
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  border-top: 1px solid #e0e0e0;
  order: 1;
}

[data-theme='dark'] .suggestion-bubbles {
  border-top-color: #555;
}

.suggestion-bubble {
  padding: 5px 9px;
  background-color: var(--assistant-message-background);
  color: var(--text-color);
  border: none;
  border-radius: 17px;
  cursor: pointer;
  font-size: 11px;
  transition: background-color 0.3s;
}

.suggestion-bubble:hover:not(.disabled) {
  background-color: var(--hover-background-color);
  color: var(--hover-text-color);
}

.suggestion-bubble.disabled {
  background-color: #6c757d;
  color: #ffffff;
  cursor: not-allowed;
  opacity: 0.6;
}

/* Thinking Styling */
.thinking-container {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 15px;
  background-color: #e3f2fd;
  border: 1px solid #bbdefb;
  border-radius: 8px;
  margin: 5px 0;
  animation: fadeIn 0.3s ease-in;
}

[data-theme='dark'] .thinking-container {
  background-color: #1a237e;
  border-color: #3f51b5;
}

/* Integrated Thinking Styling */
.integrated-thinking-container {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 15px;
  background-color: #e3f2fd;
  border: 1px solid #bbdefb;
  border-radius: 8px;
  margin: 5px 0;
  animation: fadeIn 0.3s ease-in;
}

[data-theme='dark'] .integrated-thinking-container {
  background-color: #1a237e;
  border-color: #3f51b5;
}

.tool-operations-details {
  margin-top: 8px;
}

.tool-operations-details summary {
  font-size: 0.85em;
  color: #6c757d;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 500;
}

[data-theme='dark'] .tool-operations-details summary {
  color: #adb5bd;
}

.tool-operations-list {
  margin-top: 8px;
}

.tool-operation-item {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 8px;
  margin-bottom: 8px;
}

[data-theme='dark'] .tool-operation-item {
  background-color: #2d3748;
  border-color: #4a5568;
}

.tool-operation-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
}

.tool-operation-header .tool-working-icon,
.tool-operation-header .tool-progress-icon {
  font-size: 14px;
}

.tool-operation-header .tool-working-text,
.tool-operation-header .tool-progress-text {
  font-size: 0.85em;
  color: #666;
}

[data-theme='dark'] .tool-operation-header .tool-working-text,
[data-theme='dark'] .tool-operation-header .tool-progress-text {
  color: #adb5bd;
}

.tool-operation-details {
  margin-top: 5px;
}

.tool-operation-details summary {
  font-size: 0.8em;
  color: #6c757d;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

[data-theme='dark'] .tool-operation-details summary {
  color: #adb5bd;
}

.thinking-icon {
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}

.thinking-text {
  flex: 1 1;
}

.thinking-message {
  font-weight: 500;
  color: #1565c0;
  font-style: italic;
}

[data-theme='dark'] .thinking-message {
  color: #90caf9;
}

/* Tool Integrated Styling */
.tool-integrated-container {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 15px;
  background-color: #fff8e1;
  border: 1px solid #ffcc02;
  border-radius: 8px;
  margin: 5px 0;
  animation: fadeIn 0.3s ease-in;
}

[data-theme='dark'] .tool-integrated-container {
  background-color: #3e2723;
  border-color: #ff9800;
}

.tool-integrated-icon {
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}

.tool-integrated-text {
  flex: 1 1;
}

.tool-integrated-message {
  font-weight: 500;
  color: #f57c00;
  margin-bottom: 5px;
}

[data-theme='dark'] .tool-integrated-message {
  color: #ffb74d;
}

/* Tool Working Styling */
.tool-working-container {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 15px;
  background-color: #fff8e1;
  border: 1px solid #ffcc02;
  border-radius: 8px;
  margin: 5px 0;
  animation: fadeIn 0.3s ease-in;
}

[data-theme='dark'] .tool-working-container {
  background-color: #3e2723;
  border-color: #ff9800;
}

.tool-working-icon {
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}

.tool-working-text {
  flex: 1 1;
}

.tool-working-message {
  font-weight: 500;
  color: #f57c00;
  margin-bottom: 5px;
}

[data-theme='dark'] .tool-working-message {
  color: #ffb74d;
}

/* Tool Progress Styling */
.tool-progress-container {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 15px;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  margin: 5px 0;
  animation: fadeIn 0.3s ease-in;
}

[data-theme='dark'] .tool-progress-container {
  background-color: #3d2f00;
  border-color: #6c5ce7;
}

.tool-progress-icon {
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}

.tool-progress-text {
  flex: 1 1;
}

.tool-progress-message {
  font-weight: 500;
  color: #856404;
  margin-bottom: 5px;
}

[data-theme='dark'] .tool-progress-message {
  color: #fdcb6e;
}

.tool-input-details,
.tool-output-details,
.tool-details {
  margin-top: 8px;
}

.tool-input-details summary,
.tool-output-details summary,
.tool-details summary {
  font-size: 0.85em;
  color: #6c757d;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

[data-theme='dark'] .tool-input-details summary,
[data-theme='dark'] .tool-output-details summary,
[data-theme='dark'] .tool-details summary {
  color: #adb5bd;
}

.tool-input-details pre,
.tool-output-details pre,
.tool-details pre {
  font-family: 'Courier New', monospace;
  font-size: 0.8em;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 8px;
  margin-top: 5px;
  overflow-x: auto;
  max-height: 200px;
  white-space: pre-wrap;
  word-break: break-word;
}

[data-theme='dark'] .tool-input-details pre,
[data-theme='dark'] .tool-output-details pre,
[data-theme='dark'] .tool-details pre {
  background-color: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

/* Tool Status Styling */
.tool-status {
  font-size: 0.8em;
  color: #666;
  margin-top: 5px;
}

[data-theme='dark'] .tool-status {
  color: #adb5bd;
}

/* Tool Details Summary Styling */
.tool-details-summary {
  cursor: pointer;
  font-size: 0.9em;
  color: #666;
}

[data-theme='dark'] .tool-details-summary {
  color: #adb5bd;
}

/* Tool Input/Output Labels */
.tool-input-label {
  font-size: 0.85em;
  color: #1976d2;
  font-weight: bold;
}

[data-theme='dark'] .tool-input-label {
  color: #64b5f6;
}

.tool-output-label {
  font-size: 0.85em;
  color: #388e3c;
  font-weight: bold;
}

[data-theme='dark'] .tool-output-label {
  color: #81c784;
}

/* Tool Input/Output Content */
.tool-input-content {
  margin-top: 10px;
}

.tool-output-content {
  margin-top: 10px;
}

.tool-input-pre {
  font-size: 0.8em;
  background-color: #e3f2fd;
  padding: 8px;
  border-radius: 4px;
  margin-top: 5px;
  overflow: auto;
  max-height: 150px;
  color: #000;
}

[data-theme='dark'] .tool-input-pre {
  background-color: #1e3a8a;
  color: #e2e8f0;
}

.tool-output-pre {
  font-size: 0.8em;
  background-color: #e8f5e8;
  padding: 8px;
  border-radius: 4px;
  margin-top: 5px;
  overflow: auto;
  max-height: 150px;
  color: #000;
}

[data-theme='dark'] .tool-output-pre {
  background-color: #1b5e20;
  color: #e2e8f0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Message Content Styling */
.message-content {
  width: 100%;
  max-width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}

.message-content p {
  margin: 0 0 10px 0;
  line-height: 1.5;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
}

.message-content p:last-child {
  margin-bottom: 0;
}

/* Table Integration */
.message-content .table-container {
  margin: 15px 0;
}

/* Ensure tables don't break the layout */
.message-content table {
  max-width: 100%;
  width: 100%;
  table-layout: fixed;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* Markdown table styling improvements */
.message-content table {
  border-collapse: collapse;
  width: 100%;
  margin: 10px 0;
}

.message-content th,
.message-content td {
  border: 1px solid #ddd;
  padding: 8px 12px;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  vertical-align: top;
  line-height: 1.4;
  box-sizing: border-box;
  overflow: hidden;
}

[data-theme='dark'] .message-content th,
[data-theme='dark'] .message-content td {
  border-color: #555;
}

.message-content th {
  background-color: #f2f2f2;
  font-weight: bold;
}

[data-theme='dark'] .message-content th {
  background-color: #2d3748;
}

/* Code blocks in messages */
.message-content pre {
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px;
  overflow-x: auto;
  margin: 10px 0;
}

[data-theme='dark'] .message-content pre {
  background-color: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.message-content code {
  background-color: #f4f4f4;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
}

[data-theme='dark'] .message-content code {
  background-color: #2d3748;
  color: #e2e8f0;
}

/* Lists in messages */
.message-content ul,
.message-content ol {
  margin: 10px 0;
  padding-left: 20px;
}

.message-content li {
  margin: 5px 0;
  line-height: 1.5;
}

/* Headings in messages */
.message-content h1,
.message-content h2,
.message-content h3,
.message-content h4,
.message-content h5,
.message-content h6 {
  margin: 15px 0 10px 0;
  color: var(--text-color);
  font-weight: 600;
}

.message-content h1 { font-size: 24px; }
.message-content h2 { font-size: 20px; }
.message-content h3 { font-size: 18px; }
.message-content h4 { font-size: 16px; }
.message-content h5 { font-size: 14px; }
.message-content h6 { font-size: 12px; }

/* Blockquotes in messages */
.message-content blockquote {
  border-left: 4px solid #ddd;
  margin: 10px 0;
  padding: 10px 15px;
  background-color: #f9f9f9;
  font-style: italic;
}

[data-theme='dark'] .message-content blockquote {
  border-left-color: #555;
  background-color: #2d3748;
}

/* Links in messages */
.message-content a {
  color: #007bff;
  text-decoration: none;
}

.message-content a:hover {
  text-decoration: underline;
}

[data-theme='dark'] .message-content a {
  color: #4a90e2;
}

/* Horizontal rules in messages */
.message-content hr {
  border: none;
  border-top: 1px solid #ddd;
  margin: 20px 0;
}

[data-theme='dark'] .message-content hr {
  border-top-color: #555;
}

/* Code Block Integration */
.message-content .code-block-wrapper {
  margin: 15px 0;
}

.message-content .code-inline {
  background: #f1f3f4;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', 'Monaco', 'Consolas', monospace;
  font-size: 0.9em;
  color: #d63384;
  cursor: context-menu;
  -webkit-user-select: text;
          user-select: text;
  position: relative;
  display: inline-block;
}

[data-theme='dark'] .message-content .code-inline {
  background: #2d3748;
  color: #f093fb;
}

.message-content .code-inline:hover {
  background: #e9ecef;
}

[data-theme='dark'] .message-content .code-inline:hover {
  background: #4a5568;
}

/* Context Menu Z-Index */
.code-context-menu {
  z-index: 10000;
}

/* Notification Styling */
.code-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #28a745;
  color: white;
  padding: 12px 20px;
  border-radius: 4px;
  z-index: 10001;
  font-size: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  animation: notificationSlideIn 0.3s ease-out;
}

.code-notification.error {
  background: #dc3545;
}

@keyframes notificationSlideIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Code Block Hover Effects */
.message-content pre:hover {
  background: #f1f3f4;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

[data-theme='dark'] .message-content pre:hover {
  background: #4a5568;
}

/* Ensure code blocks are properly styled */
.message-content pre code {
  background: none;
  padding: 0;
  border: none;
  border-radius: 0;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
}

/* Code block wrapper styling */
.message-content .code-block-wrapper {
  position: relative;
  margin: 15px 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: var(--background-color);
  border: 1px solid #e0e0e0;
}

[data-theme='dark'] .message-content .code-block-wrapper {
  background: var(--background-color);
  border-color: #555;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,kCAAkC;EAClC,iCAAiC;EACjC,uBAAuB;EACvB,kCAAkC;EAClC,uCAAuC;EACvC,iCAAiC;EACjC,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,kCAAkC;EAClC,iCAAiC;EACjC,uBAAuB;EACvB,kCAAkC;EAClC,uCAAuC;EACvC,iCAAiC;EACjC,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD,kDAAkD;;;AAGlD,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;EAChD,2CAA2C;EAC3C,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,gDAAgD;EAChD,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,+CAA+C;EAC/C,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,uCAAuC;EACvC,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA,eAAe;;AAEf;;;;;;;;;;;;;;;;;;CAkBC;;AAED;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;EACE;IACE,mBAAmB;IACnB,4CAA4C;EAC9C;EACA;IACE,qBAAqB;IACrB,6CAA6C;EAC/C;EACA;IACE,mBAAmB;IACnB,4CAA4C;EAC9C;AACF;;;AAGA,sBAAsB;AACtB;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,+BAA+B;AACjC;;AAEA,wCAAwC;AACxC;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,SAAS;AACX;;AAEA,uDAAuD;AACvD,mCAAmC;AACnC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,qBAAqB,EAAE,YAAY;AACrC;;AAEA,8CAA8C;AAC9C;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uDAAuD;EACvD,gEAAgE;EAChE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B,EAAE,aAAa;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2DAA2D;EAC3D,YAAY,EAAE,mBAAmB;AACnC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,+BAA+B;EAC/B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,SAAS;EACT,QAAQ;EACR,+BAA+B;AACjC;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,gDAAgD;EAChD,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qDAAqD;EACrD,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,qCAAqC;EACrC,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;;;;;;EAME,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,sBAAsB,eAAe,EAAE;AACvC,sBAAsB,eAAe,EAAE;AACvC,sBAAsB,eAAe,EAAE;AACvC,sBAAsB,eAAe,EAAE;AACvC,sBAAsB,eAAe,EAAE;AACvC,sBAAsB,eAAe,EAAE;;AAEvC,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,2DAA2D;EAC3D,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,wCAAwC;AAC1C","sourcesContent":["/* Light Theme */\n:root {\n  --background-color: #ffffff;\n  --text-color: #333333;\n  --header-background-color: #ffffff;\n  --input-background-color: #f2f2f2;\n  --button-color: #4a4a4a;\n  --user-message-background: #d3d3d3;\n  --assistant-message-background: #f9f9f9;\n  --hover-background-color: #e0e0e0; \n  --hover-text-color: #333333;\n  --sidebar-background: #f8f9fa;\n  --sidebar-border: #e9ecef;\n  --accent-color: #007bff;\n  --card-background: #ffffff;\n  --card-border: #e9ecef;\n  --card-hover: #f8f9fa;\n  --muted-color: #6c757d;\n  --divider-color: #e9ecef;\n  --success-color: #28a745;\n  --success-hover: #218838;\n  --scrollbar-color: #cbd5e0;\n  --scrollbar-hover: #a0aec0;\n}\n\n/* Dark Theme (default) */\n[data-theme='dark'] {\n  --background-color: #1e1e1e;\n  --text-color: #e0e0e0;\n  --header-background-color: #333333;\n  --input-background-color: #2e2e2e;\n  --button-color: #d3d3d3;\n  --user-message-background: #2f2f2f;\n  --assistant-message-background: #444444;\n  --hover-background-color: #555555; \n  --hover-text-color: #e0e0e0;\n  --sidebar-background: #2d3748;\n  --sidebar-border: #4a5568;\n  --accent-color: #4a90e2;\n  --card-background: #4a5568;\n  --card-border: #718096;\n  --card-hover: #2d3748;\n  --muted-color: #a0aec0;\n  --divider-color: #4a5568;\n  --success-color: #28a745;\n  --success-hover: #218838;\n  --scrollbar-color: #4a5568;\n  --scrollbar-hover: #718096;\n}\n\n/* General styling */\nbody, html {\n  margin: 0;\n  padding: 0;\n  font-family: Arial, sans-serif;\n  height: 100%;\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n/* App Container - Keep original layout intact */\n.app-container {\n  position: relative;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  max-width: 100vw;\n}\n\n/* Sidebar will overlay on top, not push content */\n/* No margin adjustments needed for main content */\n\n\n/* Header styling */\n.site-header {\n  display: flex;\n  justify-content: space-between; \n  align-items: center;\n  padding: 10px 30px;\n  background-color: var(--header-background-color);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  flex-shrink: 0;\n  height: 60px;\n  position: relative;\n}\n\n.site-logo {\n  width: 160px; \n  height: auto;\n}\n\n\n.header-text {\n  position: absolute; \n  left: 50%; \n  transform: translateX(-50%);\n  text-align: center;\n  padding-top:5px;\n}\n\n\n.header-text h2 {\n  margin: 0;\n  font-size: 28px;\n  color: var(--text-color);\n  font-weight: 600;\n}\n\n.header-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 14px;\n  color: var(--text-color);\n  opacity: 0.8;\n  font-weight: 400;\n  line-height: 1.3;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  position: absolute;\n  right: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.guided-run-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n  position: relative;\n  overflow: hidden;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.guided-run-btn:hover {\n  transform: translateY(-3px) scale(1.05);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);\n}\n\n.guided-run-btn:active {\n  transform: translateY(-1px) scale(1.02);\n}\n\n.guided-run-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);\n  transition: left 0.5s;\n}\n\n.guided-run-btn:hover::before {\n  left: 100%;\n}\n\n/* Theme toggle positioning */\n.theme-toggle {\n  z-index: 10;\n}\n\n.theme-toggle-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  color: var(--button-color);\n  margin-left: auto;\n}\n\n/* Chat container */\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  background-color: var(--background-color);\n  margin: 0 auto;\n  max-width: 900px;\n  width: 100%;\n  padding: 0 20px;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  min-height: 0;\n  box-sizing: border-box;\n}\n\n/* Responsive design for chat container */\n@media (max-width: 1024px) {\n  .chat-container {\n    max-width: 800px;\n    padding: 0 15px;\n  }\n}\n\n@media (max-width: 768px) {\n  .chat-container {\n    max-width: 100%;\n    padding: 0 10px;\n  }\n}\n\n/* Chat window */\n.chat-window {\n  flex: 1;\n  padding: 20px 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  scroll-behavior: smooth;\n  box-sizing: border-box;\n}\n\n/* User message bubble */\n.user-message {\n  align-self: flex-end;\n  background-color: var(--user-message-background);\n  color: var(--text-color);\n  border-radius: 18px;\n  padding: 0px 15px;\n  margin-bottom: 10px;\n  max-width: 75%;\n  font-family: 'Inter', Arial, sans-serif;\n  font-size: 14px;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n/* Assistant message */\n.assistant-message-container {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.assistant-icon {\n  width: 30px;\n  height: 30px;\n  margin-right: 10px;\n}\n\n.assistant-text {\n  \n  max-width: 80%;\n  padding: 10px;\n  font-family: 'Inter', Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.5;\n  border-radius: 15px;\n}\n\n.assistant-text {\n  color: var(--text-color);\n  max-width: 100%;\n  padding: 10px;\n  font-family: 'Inter', Arial, sans-serif;\n  font-size: 16px; \n  line-height: 1.5; \n  width: 100%; \n}\n\n/* Input area */\n.input-area {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  background-color: transparent;\n  border-top: none;\n  max-width: 100%;\n  position: relative;\n  flex-shrink: 0;\n  order: 2;\n}\n\n.chat-input-container {\n  position: relative;\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n}\n\n.chat-input {\n  flex-grow: 1;\n  padding: 15px;\n  font-size: 14px;\n  border: none;\n  border-radius: 50px;\n  padding: 15px 90px 15px 40px;\n  background-color: var(--input-background-color);\n  color: var(--text-color);\n  outline: none;\n  resize: none;\n  font-family: 'Inter', Arial, sans-serif;\n  height: 25px;\n  line-height: 26px;\n}\n\n/* Send button */\n.send-button {\n  position: absolute;\n  right: 45px;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--button-color);\n  transition: all 0.2s ease;\n}\n\n.send-button:hover:not(.disabled) {\n  color: #0056b3;\n  transform: translateY(-1px);\n}\n\n.send-button.disabled {\n  color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n  transform: none;\n}\n\n/* Mic button */\n\n/*\n.mic-button {\n  position: absolute;\n  right: 9px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  color: var(--button-color);\n}\n\n.mic-button.recording {\n  border: 3px solid green;\n  border-radius: 50%;\n  padding: 5px;\n}\n\n*/\n\n.mic-button {\n  position: absolute;\n  right: 9px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  color: var(--button-color);\n  transition: transform 0.3s ease-in-out;\n}\n\n.mic-button.disabled {\n  color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n  transform: none;\n}\n\n.mic-button.recording {\n  border: 3px solid green;\n  border-radius: 50%;\n  padding: 5px;\n  animation: pulse-glow 1.5s infinite ease-in-out;\n  box-shadow: 0 0 8px 3px rgba(0, 255, 0, 0.5); \n}\n\n@keyframes pulse-glow {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 8px 3px rgba(0, 255, 0, 0.5);\n  }\n  50% {\n    transform: scale(1.1);\n    box-shadow: 0 0 10px 5px rgba(0, 255, 0, 0.7);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 8px 3px rgba(0, 255, 0, 0.5);\n  }\n}\n\n\n/* Loading indicator */\n.loading-indicator {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-left: 10px;\n  margin-bottom: 20px;\n  padding: 10px 0;\n}\n\n.dot {\n  font-size: 24px;\n  margin: 0 3px;\n  color: #888;\n  animation: bounce 1.5s infinite;\n}\n\n/* Bouncing animation for loading dots */\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n\n/* Adding delay for each dot to bounce in sequence */\n.loading-indicator .dot:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.loading-indicator .dot:nth-child(2) {\n  animation-delay: 0.3s;\n}\n\n.loading-indicator .dot:nth-child(3) {\n  animation-delay: 0.6s;\n}\n\n\n/* Attachment button */\n.attachment-button {\n  position: absolute;\n  left: 10px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  color: var(--button-color);\n  top: 17px;\n}\n\n/* Hide scrollbar in Webkit browsers (Chrome, Safari) */\n/* Show scrollbar for chat window */\n.chat-window::-webkit-scrollbar {\n  width: 8px;\n}\n\n.chat-window::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chat-window::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 4px;\n}\n\n.chat-window::-webkit-scrollbar-thumb:hover {\n  background: #999;\n}\n\n[data-theme='dark'] .chat-window::-webkit-scrollbar-thumb {\n  background: #555;\n}\n\n[data-theme='dark'] .chat-window::-webkit-scrollbar-thumb:hover {\n  background: #777;\n}\n\n/* Hide scrollbar for input only */\n.chat-input::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar in Firefox for input only */\n.chat-input {\n  scrollbar-width: none; /* Firefox */\n}\n\n/* Hide scrollbar in IE, Edge for input only */\n.chat-input {\n  -ms-overflow-style: none;\n}\n\n.theme-toggle-switch {\n  position: relative;\n  width: 50px;\n  height: 24px;\n  border-radius: 12px;\n  background: linear-gradient(to right, #FFF4E0, #FFE8CC);\n  /* old background: linear-gradient(to right, #b0d4ff, #82b1ff);*/\n  cursor: pointer;\n  transition: background 0.3s ease;\n  display: flex;\n  align-items: center;\n}\n\n.theme-toggle-switch:before {\n  content: '☀️';\n  position: absolute;\n  top: 2.5px;\n  left: 4px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background-color: transparent; /* old white*/\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n  color: black; /* old transparent*/\n}\n\n.theme-toggle-switch:after {\n  position: absolute;\n  top: 8px;\n  left: 28px;\n  font-size: 6px;\n  color: rgba(255, 255, 255, 0.8);\n  opacity: 1;\n  transition: opacity 0.3s ease;\n}\n\n[data-theme='dark'] .theme-toggle-switch {\n  background: linear-gradient(to right, #334, #223);\n}\n\n[data-theme='dark'] .theme-toggle-switch:before {\n  content: '🌙';\n  transform: translateX(26px);\n  background-color: transparent;\n  color: white;\n}\n\n[data-theme='dark'] .theme-toggle-switch:after {\n  font-size: 8px;\n  left: 6px;\n  top: 4px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n\n.file-upload-bubble {\n  display: flex;\n  align-items: center;\n  background-color: var(--user-message-background);\n  color: var(--text-color);\n  padding: 8px 10px; \n  border-radius: 12px;\n  max-width: 250px; \n  margin-bottom: 10px;\n  overflow: hidden;\n}\n\n.file-icon {\n  font-size: 18px; \n  color: #4a90e2;\n  margin-right: 8px;\n}\n\n.file-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-color);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.suggestion-bubbles {\n  display: flex;\n  gap: 10px;\n  padding: 10px 20px;\n  background-color: var(--background-color);\n  justify-content: center;\n  flex-shrink: 0;\n  position: relative;\n  z-index: 1;\n  border-top: 1px solid #e0e0e0;\n  order: 1;\n}\n\n[data-theme='dark'] .suggestion-bubbles {\n  border-top-color: #555;\n}\n\n.suggestion-bubble {\n  padding: 5px 9px;\n  background-color: var(--assistant-message-background);\n  color: var(--text-color);\n  border: none;\n  border-radius: 17px;\n  cursor: pointer;\n  font-size: 11px;\n  transition: background-color 0.3s;\n}\n\n.suggestion-bubble:hover:not(.disabled) {\n  background-color: var(--hover-background-color);\n  color: var(--hover-text-color);\n}\n\n.suggestion-bubble.disabled {\n  background-color: #6c757d;\n  color: #ffffff;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Thinking Styling */\n.thinking-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 15px;\n  background-color: #e3f2fd;\n  border: 1px solid #bbdefb;\n  border-radius: 8px;\n  margin: 5px 0;\n  animation: fadeIn 0.3s ease-in;\n}\n\n[data-theme='dark'] .thinking-container {\n  background-color: #1a237e;\n  border-color: #3f51b5;\n}\n\n/* Integrated Thinking Styling */\n.integrated-thinking-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 15px;\n  background-color: #e3f2fd;\n  border: 1px solid #bbdefb;\n  border-radius: 8px;\n  margin: 5px 0;\n  animation: fadeIn 0.3s ease-in;\n}\n\n[data-theme='dark'] .integrated-thinking-container {\n  background-color: #1a237e;\n  border-color: #3f51b5;\n}\n\n.tool-operations-details {\n  margin-top: 8px;\n}\n\n.tool-operations-details summary {\n  font-size: 0.85em;\n  color: #6c757d;\n  cursor: pointer;\n  user-select: none;\n  font-weight: 500;\n}\n\n[data-theme='dark'] .tool-operations-details summary {\n  color: #adb5bd;\n}\n\n.tool-operations-list {\n  margin-top: 8px;\n}\n\n.tool-operation-item {\n  background-color: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  padding: 8px;\n  margin-bottom: 8px;\n}\n\n[data-theme='dark'] .tool-operation-item {\n  background-color: #2d3748;\n  border-color: #4a5568;\n}\n\n.tool-operation-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 5px;\n}\n\n.tool-operation-header .tool-working-icon,\n.tool-operation-header .tool-progress-icon {\n  font-size: 14px;\n}\n\n.tool-operation-header .tool-working-text,\n.tool-operation-header .tool-progress-text {\n  font-size: 0.85em;\n  color: #666;\n}\n\n[data-theme='dark'] .tool-operation-header .tool-working-text,\n[data-theme='dark'] .tool-operation-header .tool-progress-text {\n  color: #adb5bd;\n}\n\n.tool-operation-details {\n  margin-top: 5px;\n}\n\n.tool-operation-details summary {\n  font-size: 0.8em;\n  color: #6c757d;\n  cursor: pointer;\n  user-select: none;\n}\n\n[data-theme='dark'] .tool-operation-details summary {\n  color: #adb5bd;\n}\n\n.thinking-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.thinking-text {\n  flex: 1;\n}\n\n.thinking-message {\n  font-weight: 500;\n  color: #1565c0;\n  font-style: italic;\n}\n\n[data-theme='dark'] .thinking-message {\n  color: #90caf9;\n}\n\n/* Tool Integrated Styling */\n.tool-integrated-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 15px;\n  background-color: #fff8e1;\n  border: 1px solid #ffcc02;\n  border-radius: 8px;\n  margin: 5px 0;\n  animation: fadeIn 0.3s ease-in;\n}\n\n[data-theme='dark'] .tool-integrated-container {\n  background-color: #3e2723;\n  border-color: #ff9800;\n}\n\n.tool-integrated-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.tool-integrated-text {\n  flex: 1;\n}\n\n.tool-integrated-message {\n  font-weight: 500;\n  color: #f57c00;\n  margin-bottom: 5px;\n}\n\n[data-theme='dark'] .tool-integrated-message {\n  color: #ffb74d;\n}\n\n/* Tool Working Styling */\n.tool-working-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 15px;\n  background-color: #fff8e1;\n  border: 1px solid #ffcc02;\n  border-radius: 8px;\n  margin: 5px 0;\n  animation: fadeIn 0.3s ease-in;\n}\n\n[data-theme='dark'] .tool-working-container {\n  background-color: #3e2723;\n  border-color: #ff9800;\n}\n\n.tool-working-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.tool-working-text {\n  flex: 1;\n}\n\n.tool-working-message {\n  font-weight: 500;\n  color: #f57c00;\n  margin-bottom: 5px;\n}\n\n[data-theme='dark'] .tool-working-message {\n  color: #ffb74d;\n}\n\n/* Tool Progress Styling */\n.tool-progress-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 15px;\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 8px;\n  margin: 5px 0;\n  animation: fadeIn 0.3s ease-in;\n}\n\n[data-theme='dark'] .tool-progress-container {\n  background-color: #3d2f00;\n  border-color: #6c5ce7;\n}\n\n.tool-progress-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.tool-progress-text {\n  flex: 1;\n}\n\n.tool-progress-message {\n  font-weight: 500;\n  color: #856404;\n  margin-bottom: 5px;\n}\n\n[data-theme='dark'] .tool-progress-message {\n  color: #fdcb6e;\n}\n\n.tool-input-details,\n.tool-output-details,\n.tool-details {\n  margin-top: 8px;\n}\n\n.tool-input-details summary,\n.tool-output-details summary,\n.tool-details summary {\n  font-size: 0.85em;\n  color: #6c757d;\n  cursor: pointer;\n  user-select: none;\n}\n\n[data-theme='dark'] .tool-input-details summary,\n[data-theme='dark'] .tool-output-details summary,\n[data-theme='dark'] .tool-details summary {\n  color: #adb5bd;\n}\n\n.tool-input-details pre,\n.tool-output-details pre,\n.tool-details pre {\n  font-family: 'Courier New', monospace;\n  font-size: 0.8em;\n  background-color: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  padding: 8px;\n  margin-top: 5px;\n  overflow-x: auto;\n  max-height: 200px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n[data-theme='dark'] .tool-input-details pre,\n[data-theme='dark'] .tool-output-details pre,\n[data-theme='dark'] .tool-details pre {\n  background-color: #2d3748;\n  border-color: #4a5568;\n  color: #e2e8f0;\n}\n\n/* Tool Status Styling */\n.tool-status {\n  font-size: 0.8em;\n  color: #666;\n  margin-top: 5px;\n}\n\n[data-theme='dark'] .tool-status {\n  color: #adb5bd;\n}\n\n/* Tool Details Summary Styling */\n.tool-details-summary {\n  cursor: pointer;\n  font-size: 0.9em;\n  color: #666;\n}\n\n[data-theme='dark'] .tool-details-summary {\n  color: #adb5bd;\n}\n\n/* Tool Input/Output Labels */\n.tool-input-label {\n  font-size: 0.85em;\n  color: #1976d2;\n  font-weight: bold;\n}\n\n[data-theme='dark'] .tool-input-label {\n  color: #64b5f6;\n}\n\n.tool-output-label {\n  font-size: 0.85em;\n  color: #388e3c;\n  font-weight: bold;\n}\n\n[data-theme='dark'] .tool-output-label {\n  color: #81c784;\n}\n\n/* Tool Input/Output Content */\n.tool-input-content {\n  margin-top: 10px;\n}\n\n.tool-output-content {\n  margin-top: 10px;\n}\n\n.tool-input-pre {\n  font-size: 0.8em;\n  background-color: #e3f2fd;\n  padding: 8px;\n  border-radius: 4px;\n  margin-top: 5px;\n  overflow: auto;\n  max-height: 150px;\n  color: #000;\n}\n\n[data-theme='dark'] .tool-input-pre {\n  background-color: #1e3a8a;\n  color: #e2e8f0;\n}\n\n.tool-output-pre {\n  font-size: 0.8em;\n  background-color: #e8f5e8;\n  padding: 8px;\n  border-radius: 4px;\n  margin-top: 5px;\n  overflow: auto;\n  max-height: 150px;\n  color: #000;\n}\n\n[data-theme='dark'] .tool-output-pre {\n  background-color: #1b5e20;\n  color: #e2e8f0;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Message Content Styling */\n.message-content {\n  width: 100%;\n  max-width: 100%;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  hyphens: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n.message-content p {\n  margin: 0 0 10px 0;\n  line-height: 1.5;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n.message-content p:last-child {\n  margin-bottom: 0;\n}\n\n/* Table Integration */\n.message-content .table-container {\n  margin: 15px 0;\n}\n\n/* Ensure tables don't break the layout */\n.message-content table {\n  max-width: 100%;\n  width: 100%;\n  table-layout: fixed;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n/* Markdown table styling improvements */\n.message-content table {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 10px 0;\n}\n\n.message-content th,\n.message-content td {\n  border: 1px solid #ddd;\n  padding: 8px 12px;\n  text-align: left;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  vertical-align: top;\n  line-height: 1.4;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n[data-theme='dark'] .message-content th,\n[data-theme='dark'] .message-content td {\n  border-color: #555;\n}\n\n.message-content th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n[data-theme='dark'] .message-content th {\n  background-color: #2d3748;\n}\n\n/* Code blocks in messages */\n.message-content pre {\n  background-color: #f4f4f4;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 12px;\n  overflow-x: auto;\n  margin: 10px 0;\n}\n\n[data-theme='dark'] .message-content pre {\n  background-color: #2d3748;\n  border-color: #4a5568;\n  color: #e2e8f0;\n}\n\n.message-content code {\n  background-color: #f4f4f4;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-family: 'Courier New', monospace;\n}\n\n[data-theme='dark'] .message-content code {\n  background-color: #2d3748;\n  color: #e2e8f0;\n}\n\n/* Lists in messages */\n.message-content ul,\n.message-content ol {\n  margin: 10px 0;\n  padding-left: 20px;\n}\n\n.message-content li {\n  margin: 5px 0;\n  line-height: 1.5;\n}\n\n/* Headings in messages */\n.message-content h1,\n.message-content h2,\n.message-content h3,\n.message-content h4,\n.message-content h5,\n.message-content h6 {\n  margin: 15px 0 10px 0;\n  color: var(--text-color);\n  font-weight: 600;\n}\n\n.message-content h1 { font-size: 24px; }\n.message-content h2 { font-size: 20px; }\n.message-content h3 { font-size: 18px; }\n.message-content h4 { font-size: 16px; }\n.message-content h5 { font-size: 14px; }\n.message-content h6 { font-size: 12px; }\n\n/* Blockquotes in messages */\n.message-content blockquote {\n  border-left: 4px solid #ddd;\n  margin: 10px 0;\n  padding: 10px 15px;\n  background-color: #f9f9f9;\n  font-style: italic;\n}\n\n[data-theme='dark'] .message-content blockquote {\n  border-left-color: #555;\n  background-color: #2d3748;\n}\n\n/* Links in messages */\n.message-content a {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.message-content a:hover {\n  text-decoration: underline;\n}\n\n[data-theme='dark'] .message-content a {\n  color: #4a90e2;\n}\n\n/* Horizontal rules in messages */\n.message-content hr {\n  border: none;\n  border-top: 1px solid #ddd;\n  margin: 20px 0;\n}\n\n[data-theme='dark'] .message-content hr {\n  border-top-color: #555;\n}\n\n/* Code Block Integration */\n.message-content .code-block-wrapper {\n  margin: 15px 0;\n}\n\n.message-content .code-inline {\n  background: #f1f3f4;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Courier New', 'Monaco', 'Consolas', monospace;\n  font-size: 0.9em;\n  color: #d63384;\n  cursor: context-menu;\n  user-select: text;\n  position: relative;\n  display: inline-block;\n}\n\n[data-theme='dark'] .message-content .code-inline {\n  background: #2d3748;\n  color: #f093fb;\n}\n\n.message-content .code-inline:hover {\n  background: #e9ecef;\n}\n\n[data-theme='dark'] .message-content .code-inline:hover {\n  background: #4a5568;\n}\n\n/* Context Menu Z-Index */\n.code-context-menu {\n  z-index: 10000;\n}\n\n/* Notification Styling */\n.code-notification {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  background: #28a745;\n  color: white;\n  padding: 12px 20px;\n  border-radius: 4px;\n  z-index: 10001;\n  font-size: 14px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  animation: notificationSlideIn 0.3s ease-out;\n}\n\n.code-notification.error {\n  background: #dc3545;\n}\n\n@keyframes notificationSlideIn {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Code Block Hover Effects */\n.message-content pre:hover {\n  background: #f1f3f4;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n[data-theme='dark'] .message-content pre:hover {\n  background: #4a5568;\n}\n\n/* Ensure code blocks are properly styled */\n.message-content pre code {\n  background: none;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  font-family: inherit;\n  font-size: inherit;\n  color: inherit;\n}\n\n/* Code block wrapper styling */\n.message-content .code-block-wrapper {\n  position: relative;\n  margin: 15px 0;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  background: var(--background-color);\n  border: 1px solid #e0e0e0;\n}\n\n[data-theme='dark'] .message-content .code-block-wrapper {\n  background: var(--background-color);\n  border-color: #555;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
